module.exports = __webpack_public_path__ + "235084eee5f4c92f7011a6b2e2aa8b8a.pdf";